import { render, staticRenderFns } from "./modalAttachExternalCompany.vue?vue&type=template&id=6206be50&"
import script from "./modalAttachExternalCompany.vue?vue&type=script&lang=js&"
export * from "./modalAttachExternalCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports